import React from "react";
import DropDownInput from "../../../../Universal/DropDownInput.component";
import PlusIcon from "../../../../../assets/Icons/Universal/PlusIconWithGreenBack.svg";
import CrossIcon from "../../../../../assets/Icons/Universal/CrossHoloIcon.svg";

const MorningShiftModalForm = ({
  values,
  handleChangeMorningTeacher,
  handleAddMorningTeacher,
  handleChangeMorningSubject,
  handleRemoveMorningSubject,
  handleAddMorningSubject,
  handleChangeMorningBestPerformer,
}) => {
  return (
    // ----------- Morning Shift Section -----------
    <div
      className="flex-col align-start justify-start g-1 scroll-y pr-05"
      style={{ height: "50vh" }}
    >
      {/* Teachers */}
      <div className="flex-col align-start justify-start g-1">
        {values.morningShift.teachers.map((teacher, index) => (
          <div className="flex" key={index} style={{ width: "14rem" }}>
            <DropDownInput
              label={`Teacher ${index + 1}`}
              name={`morningShift.teacher${index + 1}`}
              value={teacher}
              placeholder="Choose teacher"
              setFieldValue={(val) => handleChangeMorningTeacher(val, index)}
              suggestionList={["Teacher1", "Teacher2"]}
            />
          </div>
        ))}
        <button
          type="button"
          onClick={handleAddMorningTeacher}
          className="w-fit transparentBtn flex-row align-center jsutify-start g-05"
        >
          <img
            src={PlusIcon}
            alt=""
            style={{ width: "1.5rem", height: "1.5rem" }}
          />
          <span className="poppins t-14">
            <b>Add new</b>
          </span>
        </button>
      </div>
      <hr />

      {/* Subjects */}
      <div className="flex-col align-start justify-start g-1">
        {values.morningShift.subjects.map((entry, index) => (
          <div className="flex-row align-center justify-start g-1" key={index}>
            <div className="w-half">
              <DropDownInput
                label={`Subject ${index + 1}`}
                name={`morningShift.subjects[${index}].subject`}
                value={entry.subject}
                placeholder="Subject name"
                setFieldValue={(val) =>
                  handleChangeMorningSubject(val, index, "subject")
                }
                suggestionList={["Sub1", "Sub2"]}
              />
            </div>
            <div className="w-half flex-col align-start justify-start g-05">
              <label className="color-black t-12 poppins">Topic</label>
              <input
                type="text"
                name="topic"
                className="textInputFieldBasic"
                value={entry.topic}
                placeholder="Enter topic"
                onChange={(e) =>
                  handleChangeMorningSubject(
                    e.target.value,
                    index,
                    e.target.name
                  )
                }
              />
            </div>
            <div className="h-full flex-col align-center justify-center">
              <button
                type="button"
                className="transparentBtn w-fit h-fit"
                style={{ marginTop: "1.5rem" }}
                onClick={() => handleRemoveMorningSubject(index)}
              >
                <img src={CrossIcon} alt="" />
              </button>
            </div>
          </div>
        ))}
        <button
          type="button"
          className="w-fit transparentBtn flex-row align-center jsutify-start g-05"
          onClick={handleAddMorningSubject}
        >
          <img
            src={PlusIcon}
            alt=""
            style={{ width: "1.5rem", height: "1.5rem" }}
          />
          <span className="poppins t-14">
            <b>Add new</b>
          </span>
        </button>
      </div>
      <hr />

      {/* Best Performers */}
      <div className="flex-col align-start justify-start g-1">
        {values.morningShift.bestPerformers.map((item, index) => (
          <div
            className="flex-row align-center justify-between g-1"
            key={index}
          >
            <div className="w-half">
              <DropDownInput
                label="Subject"
                name={`morningShift.bestPerformers[${index}].subject`}
                value={item.subject}
                placeholder="Subject"
                setFieldValue={(val) =>
                  handleChangeMorningBestPerformer(index, "subject", val)
                }
                suggestionList={values.morningShift.subjects.map(
                  (s, i) => s.subject || `Sub${i + 1}`
                )}
              />
            </div>
            <div className="w-half">
              <DropDownInput
                label="Performer"
                name={`morningShift.bestPerformers[${index}].name`}
                value={item.name}
                placeholder="Performer"
                setFieldValue={(val) =>
                  handleChangeMorningBestPerformer(index, "name", val)
                }
                suggestionList={["Student A", "Student B", "Student C"]}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MorningShiftModalForm;
